module.exports = __webpack_public_path__ + "static/image13-78a52aa54f08a8136081ff4688f1ec4d.jpeg";